import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CHART_COLORS, STAGE_LABELS } from '../vacationOverviewPage.definitions';
import { ChartTooltip } from './ChartTooltip';
import { EmptyChart } from './DashboardCard';

interface StageBarsProps {
	counts: Record<'manager' | 'client' | 'dp' | 'correction', number>;
	total: number;
	onStageClick?: (stage: 'manager' | 'client' | 'dp' | 'correction') => void;
}

export function StageBars({ counts, total, onStageClick }: StageBarsProps) {
	if (total === 0) {
		return <EmptyChart message="Nenhum pedido aguardando aprovação." />;
	}

	const data = (Object.keys(STAGE_LABELS) as Array<'manager' | 'client' | 'dp' | 'correction'>).map(stage => ({
		stage: STAGE_LABELS[stage],
		stageKey: stage,
		count: counts[stage],
	}));

	const handleBarClick = (entry: any) => {
		onStageClick?.(entry.stageKey);
	};

	return (
		<ResponsiveContainer width="100%" height={220}>
			<BarChart data={data} layout="vertical" margin={{ top: 0, right: 32, left: 8, bottom: 0 }}>
				<CartesianGrid stroke={CHART_COLORS.grid} horizontal={false} />
				<XAxis type="number" allowDecimals={false} hide />
				<YAxis type="category" dataKey="stage" width={72} tick={{ fontSize: 12, fill: CHART_COLORS.axis }} axisLine={false} tickLine={false} />
				<Tooltip content={<ChartTooltip unit=" pedido(s)" />} cursor={{ fill: '#f1f5f9' }} />
				<Bar
					dataKey="count"
					name="Pedidos"
					fill={CHART_COLORS.bar}
					radius={[0, 4, 4, 0]}
					barSize={22}
					onClick={handleBarClick}
					cursor={onStageClick ? 'pointer' : 'default'}
				>
					<LabelList dataKey="count" position="right" style={{ fontSize: 12, fontWeight: 600, fill: '#0f172a' }} />
				</Bar>
			</BarChart>
		</ResponsiveContainer>
	);
}
